import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminDockerImages = {
  pageTitle: "Shared Container Images",
  pageSubtitle:
    "Read-only view of enabled shared container images from Environment Center for business instantiation and reference checks.",
  summary: {
    total: "Total images: {count}",
    configuredPorts: "Configured ports: {count}",
    defaultPorts: "Default ports: {count}",
    sourceSnapshots: "Source snapshots: {count}",
  },
  guidance: {
    baseImageHint:
      "This list is the Environment Center shared image projection and is only used for instantiation and reference checks.",
  },
  table: {
    code: commonShortFieldLabels.code,
    name: "Image Identifier",
    displayName: "Image Name",
    id: "ID",
    size: "Size",
    declaredPorts: "Declared Ports",
    effectivePorts: "Effective Ports",
    createdAt: commonShortFieldLabels.createdAt,
    description: "Description",
    tags: "Tags",
    sourceInstance: "Source Instance",
    businessReferences: "Business References",
    status: commonShortNouns.status,
    actions: "Actions",
  },
  references: {
    referenceType: "Reference Type",
    resourceType: "Resource Type",
    resourceId: "Resource ID",
    label: "Display Name",
    status: commonShortNouns.status,
    updatedAt: commonShortFieldLabels.updatedAt,
    totalReferences: "Total references: ",
  },
  dialogs: {
    pullTitle: "Pull Image",
    importTitle: "Import Image Package (tar)",
    importHint:
      "Import image packages exported by `docker save`; the image list will refresh automatically after import.",
    currentFile: "Current file: {name}",
    noFileSelected: "No file selected",
    buildDockerfileTitle: "Build Image from Dockerfile",
    metadataTitle: "Image Port Configuration",
    customFieldsTitle: "Image Custom Fields",
    declaredPortsTitle: "Image Declared Ports (EXPOSE)",
    selectablePortsTitle: "Selectable Ports",
    defaultPortTitle: "Default Port",
    instantiateTitle: "Instantiate Image",
    referenceTitle: "Image Business References",
  },
  form: {
    imageName: "Image Identifier",
    imageNameRequired: "Please input an image identifier",
    imageNamePlaceholder: "For example: nginx:alpine",
    importSource: "Import Source",
    importSourceUpload: "Upload tar in browser",
    importSourceAsset: "Select tar from assets",
    assetPlaceholder: "Search and select tar asset",
    assetHint:
      "Upload tar to Assets first, then import from Assets to avoid unstable large browser uploads.",
    description: "Description",
    descriptionPlaceholder: "Image description",
    tags: "Tags (comma-separated)",
    tagsPlaceholder: "For example: v1.1,practical",
    dockerfileContent: "Dockerfile Content",
    dockerfileContentRequired: "Please input Dockerfile content",
    dockerfileContentPlaceholder:
      "For example:\nFROM nginx:alpine\nCOPY ./site /usr/share/nginx/html",
    buildArgsJson: "Build Args JSON (optional)",
    buildArgsJsonPlaceholder: 'For example: {"HTTP_PROXY":"http://proxy:3128"}',
    noCacheBuild: "No cache build (--no-cache)",
    buildArgsJsonInvalid: "Invalid build args JSON; object format is required.",
    noDeclaredPorts: "This image declares no ports. Add EXPOSE in the image first.",
    selectAllPorts: "Select All",
    clearPorts: "Clear",
    selectAtLeastOnePort: "Select at least one selectable port.",
    selectSelectablePortFirst: "Select at least one port in Selectable Ports first.",
    currentPortConfig: "Current configuration: {count} selectable, default {port}",
    metadataHint:
      "Question creation will show the port dropdown based on this configuration; without it, declared image ports are used.",
  },
  actions: {
    importTar: "Import tar",
    buildDockerfile: "Build Dockerfile",
    startBuild: "Start Build",
    pullImage: "Pull Image",
    viewReferences: "View References",
    instantiate: "Instantiate",
    configurePorts: "Configure Ports",
    customFields: "Custom Fields",
  },
  statuses: {
    available: "Available",
  },
  confirmDelete: {
    title: "Delete this image?",
  },
  messages: {
    pullSuccess: "Image pull completed",
    removeSuccess: "Image deleted",
    importSuccess: "Image import completed",
    importSuccessWithCount: "Image import completed; detected {count} images",
    buildSuccess: "Image build completed",
    buildSuccessWithImage: "Image build completed: {image}",
    metadataUpdated: "Image port configuration updated",
    customFieldsSaved: "Image custom fields saved",
  },
  logs: {
    importTitle: "Import Logs",
    buildTitle: "Build Logs",
  },
} as const;
